var _circle, _circle2, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#E56D39"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 12,
    fill: "#E59539"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_39_1519",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_39_1519)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3333 19.3332C9.32218 19.3332 8.45829 18.9832 7.74163 18.2832C7.02496 17.5832 6.66663 16.7276 6.66663 15.7165C6.66663 14.8498 6.92774 14.0776 7.44996 13.3998C7.97218 12.7221 8.65551 12.2887 9.49996 12.0998C9.77774 11.0776 10.3333 10.2498 11.1666 9.6165C12 8.98317 12.9444 8.6665 14 8.6665C15.3 8.6665 16.4027 9.11928 17.3083 10.0248C18.2138 10.9304 18.6666 12.0332 18.6666 13.3332C19.4333 13.4221 20.0694 13.7526 20.575 14.3248C21.0805 14.8971 21.3333 15.5665 21.3333 16.3332C21.3333 17.1665 21.0416 17.8748 20.4583 18.4582C19.875 19.0415 19.1666 19.3332 18.3333 19.3332H14.6666C14.3 19.3332 13.9861 19.2026 13.725 18.9415C13.4638 18.6804 13.3333 18.3665 13.3333 17.9998V14.5665L12.2666 15.5998L11.3333 14.6665L14 11.9998L16.6666 14.6665L15.7333 15.5998L14.6666 14.5665V17.9998H18.3333C18.8 17.9998 19.1944 17.8387 19.5166 17.5165C19.8388 17.1943 20 16.7998 20 16.3332C20 15.8665 19.8388 15.4721 19.5166 15.1498C19.1944 14.8276 18.8 14.6665 18.3333 14.6665H17.3333V13.3332C17.3333 12.4109 17.0083 11.6248 16.3583 10.9748C15.7083 10.3248 14.9222 9.99984 14 9.99984C13.0777 9.99984 12.2916 10.3248 11.6416 10.9748C10.9916 11.6248 10.6666 12.4109 10.6666 13.3332H10.3333C9.68885 13.3332 9.13885 13.5609 8.68329 14.0165C8.22774 14.4721 7.99996 15.0221 7.99996 15.6665C7.99996 16.3109 8.22774 16.8609 8.68329 17.3165C9.13885 17.7721 9.68885 17.9998 10.3333 17.9998H12V19.3332H10.3333Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.b34acd313a6e9446d8d9dc94331ea7a3.svg";
export { ForwardRef as ReactComponent };